
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"15","viewBox":"0 0 16 15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11 10.215C11.4639 10.215 11.84 9.83892 11.84 9.375C11.84 8.91108 11.4639 8.535 11 8.535C10.5361 8.535 10.16 8.91108 10.16 9.375C10.16 9.83892 10.5361 10.215 11 10.215Z","fill":"currentColor"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11 10.875C10.4525 10.875 9.3575 11.145 9.32 11.685C9.695 12.2175 10.31 12.5625 11 12.5625C11.69 12.5625 12.305 12.2175 12.68 11.685C12.6425 11.145 11.5475 10.875 11 10.875Z","fill":"currentColor"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.75 6.0675V2.4525L6.125 0L0.5 2.4525V6.135C0.5 9.54 2.9 12.7275 6.125 13.5C6.5375 13.4025 6.935 13.26 7.325 13.0875C8.135 14.2425 9.4775 15 11 15C13.4825 15 15.5 12.9825 15.5 10.5C15.5 8.2725 13.88 6.4275 11.75 6.0675ZM6.5 10.5C6.5 10.92 6.56 11.3325 6.6725 11.715C6.4925 11.7975 6.3125 11.88 6.125 11.94C3.7475 11.19 2 8.76 2 6.135V3.435L6.125 1.635L10.25 3.435V6.0675C8.12 6.4275 6.5 8.2725 6.5 10.5ZM11 13.5C9.3425 13.5 8 12.1575 8 10.5C8 8.8425 9.3425 7.5 11 7.5C12.6575 7.5 14 8.8425 14 10.5C14 12.1575 12.6575 13.5 11 13.5Z","fill":"currentColor"}})])
          )
        }
      }
    